import React from "react";
import BasicSelect from "@components/Select";
import locale from "@bonliva-crm/locale";
import { Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type ExpKnownSystemProp = {
  options: string[];
  onChange: (v: string[]) => void;
  value: string[];
  hasValidated?: boolean;
  validate?: (e, checked) => void;
};

export function ExpKnownSystem(props: ExpKnownSystemProp) {
  const { options, onChange, value, hasValidated, validate } = props;
  const classes = useStyles({});

  return (
    <Grid item xs={12} className={!hasValidated && validate ? classes.notApproved : ""}>
      {!hasValidated && validate && (
        <FormControlLabel
          style={{ float: "right" }}
          control={
            <Checkbox
              checked={false}
              className={classes.approve}
              onChange={validate}
              value="validate"
              color="secondary"
            />
          }
          label={<Typography className={classes.approve}>{locale.Approve}</Typography>}
          labelPlacement="start"
        />
      )}

      <BasicSelect
        label={locale["Known systems"]}
        fullWidth
        multi
        options={options.map((x) => ({
          label: x,
          value: x
        }))}
        sortOptions={true}
        optionType={"checkbox"}
        multiType={"chips"}
        onChange={onChange}
        value={value}
      />
    </Grid>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  approve: {
    color: theme.palette.error.main
  },
  notApproved: {
    ...theme.palette.error
  }
}));
